var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6257 12.5C15.6257 14.2259 14.2266 15.625 12.5007 15.625C10.7749 15.625 9.37573 14.2259 9.37573 12.5C9.37573 10.7741 10.7749 9.375 12.5007 9.375C14.2266 9.375 15.6257 10.7741 15.6257 12.5Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5012 5.20837C7.83698 5.20837 3.88878 8.27387 2.5614 12.5C3.88876 16.7262 7.83698 19.7917 12.5012 19.7917C17.1654 19.7917 21.1136 16.7262 22.441 12.5C21.1136 8.27391 17.1654 5.20837 12.5012 5.20837Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.ad1b2319b46aa27ac71b97b91fba6241.svg";
export { ForwardRef as ReactComponent };